import { motion, useScroll, useTransform } from "framer-motion";
import { useRef, ReactNode } from "react";

interface ScrollSectionProps {
  children: ReactNode;
  className?: string;
  parallaxSpeed?: number;
  id?: string;
}

/**
 * Composant wrapper pour les sections avec animations de scroll premium
 * Inspiré de Framer et Webflow interactions
 */
export const ScrollSection = ({
  children,
  className = "",
  parallaxSpeed = 0.5,
  id,
}: ScrollSectionProps) => {
  const ref = useRef<HTMLElement | null>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  // Parallax léger pour le background (seulement si parallaxSpeed > 0)
  // Toujours appeler useTransform pour respecter les règles des hooks React
  const y = useTransform(scrollYProgress, [0, 1], [0, parallaxSpeed > 0 ? parallaxSpeed * 50 : 0]);

  return (
    <section ref={ref} id={id} className={className}>
      {parallaxSpeed > 0 ? <motion.div style={{ y }}>{children}</motion.div> : children}
    </section>
  );
};
